/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Add custom class to Instagram section
  function addInstagramClass() {
    // Method 1: Find by Instagram feed container
    const instagramContainer = document.querySelector('#instagrid-feed-container');
    if (instagramContainer) {
      const section = instagramContainer.closest('.shopify-section');
      if (section) {
        section.classList.add('instagram-custom-bg');
        console.log('Instagram class added via container method');
      }
    }
    
    // Method 2: Find by section type (backup method)
    const instagramSections = document.querySelectorAll('[data-section-type*="instagram_feed"]');
    instagramSections.forEach(section => {
      section.classList.add('instagram-custom-bg');
      console.log('Instagram class added via section type method');
    });
    
    // Method 3: Find by app block class (another backup)
    const appBlocks = document.querySelectorAll('.shopify-app-block');
    appBlocks.forEach(block => {
      if (block.querySelector('#instagrid-feed-container')) {
        const section = block.closest('.shopify-section');
        if (section) {
          section.classList.add('instagram-custom-bg');
          console.log('Instagram class added via app block method');
        }
      }
    });
  }

  // Run when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addInstagramClass);
  } else {
    addInstagramClass();
  }

  // Also run after a short delay to catch dynamically loaded content
  setTimeout(addInstagramClass, 1000);







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
